<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="categorias.content"
      class="elevation-1 mt-5"
      :loading="loading"
      :server-items-length="categorias.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma categoria encontrada"
      loading-text="Carregando categorias..."
      :options="optionsList"
    >
      <template v-slot:item.ativo="{ item }">
        <px-ativo :ativo="item.ativo"/>
      </template>
      <template v-slot:item.fixo="{ item }">
        <px-boolean-sim-nao :value="item.fixo"/>
      </template>
      <template v-slot:item.options="{ item }">
        <px-cadastro-categoria @change="onUpdate" :categoria-edit="item">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </px-cadastro-categoria>
        <v-btn icon @click="onClickDelete(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import CategoriaService from './categoria-service';
import CadastroCategoria from './CadastroCategoria.vue';

export default {
  props: {
    categorias: Object,
    loading: Boolean,
    optionsList: Object,
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Descrição',
          value: 'descricao',
        },
        {
          text: 'Ordenação',
          value: 'ordenacao',
        },
        {
          text: 'Grupo',
          value: 'grupo.descricao',
        },
        {
          text: 'Ativo',
          value: 'ativo',
        },
        {
          text: 'Fixo',
          value: 'fixo',
        },
        {
          text: 'Ícone',
          value: 'icon',
        },
        {
          text: 'Visualização de preço',
          value: 'visualizacaoPreco',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  methods: {
    onUpdate() {
      this.$emit('update');
    },
    updateOptions(options) {
      this.$emit('change', options);
    },
    deleteItem(item) {
      CategoriaService.remove(item.id)
        .then(() => {
          this.$toast('Categoria removida', { color: 'success' });
          this.onUpdate();
        });
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja deletar a categoria?',
        'Esta ação não poderá ser desfeita!',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.deleteItem(item);
        });
    },
    goToCompradores(item) {
      this.$router.push({
        name: 'main.entidades.compradores',
        params: {
          id: item.id,
        },
      });
    },
  },
  components: {
    pxCadastroCategoria: CadastroCategoria,
  },
};
</script>
